<template>
    <div>
        <h5 class="mb-4">Property Facts</h5>

        <container>
            <row>
                <column v-for="(truth, index) in property.truths" :md="6" :lg="8" :key="`property-${property.id}-truth-${truth.id}-${index}`">
                    <h6 v-if="truth.title">{{ truth.title }}</h6>
                    <p v-if="truth.description" class="text-wrap-pre-line text-muted">{{ truth.description }}</p>
                </column>
            </row>
        </container>
    </div>
</template>

<script type="text/javascript">
    import CommonComponents from '@/components/Common.vue';
    import ApiObject from '@/classes/ApiObject.js';

    export default {
        components: {
            ...CommonComponents,
        },

        props: {
            property: {
                type: ApiObject,
                required: true,
            },
        },

    };

</script>
